/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Dashboard_Billing_Past_UsedInputs */



/**
* | output |
* | --- |
* | "Used {amount}" |
*
* @param {Dashboard_Billing_Past_UsedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_past_used = /** @type {((inputs: Dashboard_Billing_Past_UsedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Past_UsedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Verbraucht ${i?.amount}`)
	return /** @type {LocalizedString} */ (`Used ${i?.amount}`)
});